<template>
  <div class="dashboard-container">
    <div class="graphs-info-container" :key="renderKey">
      <CardDashboard
        class="graphs-info-container__item"
        :title="'Inland modes share'"
        :type="'graphCard'"
        accent-color="#4fdefa"
      >
        <v-chart @click="selectedGraphItemOption($event, 'modes')" v-if="hasModesLoadData" class="chart" :option="optionModesGraph" autoresize />
        <NotFoundData v-else />
      </CardDashboard>
      <CardDashboard
        class="graphs-info-container__item"
        :title="'Top Carriers'"
        :type="'graphCard'"
        accent-color="#E65100"
      >
        <RankingList
          :data="topCarriersData"
          :loading="topCarriersLoading"
          accent-color="#E65100"
        />
      </CardDashboard>
      <CardDashboard
        class="graphs-info-container__item"
        :title="'Most used accessorial'"
        :type="'graphCard'"
        accent-color="#2E7D32"
      >
        <RankingList
          :data="mostUsedAccessorialsData"
          :loading="mostUsedAccessorialsLoading"
          accent-color="#2E7D32"
        />
      </CardDashboard>
      <CardDashboard
        class="graphs-info-container__item graphs-info-container__item--fourth"
        :title="'USA'"
        :type="'graphCard'"
      >
        <v-chart
          @click="selectedGraphItemOption($event, 'map')"
          class="chart"
          id="map-chart"
          :option="optionMapGraph"
          autoresize
        />
      </CardDashboard>
      <CardDashboard
        class="graphs-info-container__item graphs-info-container__item--fifth"
        :class="!hasLoadsInCanada ? 'long-map' : ''"
        :title="'MEXICO'"
        :type="'graphCard'"
        v-if="hasLoadsInMexico"
      >
        <v-chart
          @click="selectedGraphItemOption($event, 'map')"
          class="chart"
          id="map-chart"
          :option="optionMapMexico"
          autoresize
        />
      </CardDashboard>
      <CardDashboard
        class="graphs-info-container__item graphs-info-container__item--sixth"
        :class="!hasLoadsInMexico ? 'long-map' : ''"
        :title="'CANADA'"
        :type="'graphCard'"
        v-if="hasLoadsInCanada"
      >
        <v-chart
          @click="selectedGraphItemOption($event, 'map')"
          class="chart"
          id="map-chart"
          :option="optionMapCanadaGraph"
          autoresize
        />
      </CardDashboard>
    </div>
  </div>
</template>

<script>
import modesPicklist from "@/utils/MyLoadsModesPicklist";
import CardDashboard from "./components/CardDashboard.vue";
import NotFoundData from "./components/NotFoundData.vue";
import RankingList from "./components/RankingList.vue";

export default {
  name: "Dashboard",
  components: {
    CardDashboard,
    NotFoundData,
    RankingList,
  },
  props: {
    loading: Boolean,
    renderKey: Number,
    optionModesGraph: Object,
    optionLoadsPerMonthGraph: Object,
    optionLoadStatusGraph: Object,
    optionPayableGraph: Object,
    optionMapGraph: Object,
    optionMapCanadaGraph: Object,
    optionMapMexico: Object,
    dataLoadsByStatus: Array,
    hasModesLoadData: Boolean,
    hasPayableData: Boolean,
    hasLoadsInMexico: Boolean,
    hasLoadsInCanada: Boolean,
    isFilterApplied: Boolean,
    topCarriersData: Array,
    mostUsedAccessorialsData: Array,
    topCarriersLoading: Boolean,
    mostUsedAccessorialsLoading: Boolean,
  },
  methods: {
    formatRankingData(data) {
      if (!data || data.length === 0) return [];
      const formatted = data.map((item) => ({
        name: item.keys.carrier_name || item.keys.accessorial_name,
        value: item.quantity,
        id: item.keys.accessorial_id,
      }));
      return formatted;
    },
    selectedGraphItemOption(params, graphName) {
      const { name } = params;
      switch (graphName) {
        case "carrier":
          this.$emit("formatMyLoadsFilterObject", { filterType: graphName, carrier: name });
          break;
        case "accessorials":
          // eslint-disable-next-line no-case-declarations
          const { id } = params.data;
          this.$emit("formatMyLoadsFilterObject", { filterType: graphName, accessorial: id });
          break;
        case "map":
          this.$emit("formatMyLoadsFilterObject", { filterType: graphName, state: name });
          break;
        case "modes":
          // eslint-disable-next-line no-case-declarations
          const [completeModeInformation] = modesPicklist.filter((mode) => mode.name === name);
          this.$emit("formatMyLoadsFilterObject", { filterType: graphName, modes: [completeModeInformation.id] });
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_dashboard-mixins' as *;

.chart {
  height: 330px !important;
  width: 100%;
}

.dashboard-container {
  width: 100%;
  max-width: 100%;
}

.graphs-info-container {
  @include dashboard-grid-container;

  &__item {
    @include dashboard-grid-item;

    &--fourth {
      grid-column: span 3;
    }
    &--fifth {
      grid-column: span 2;
    }
    &--sixth {
      grid-column: span 1;
    }
    &.long-map {
      grid-column: span 3;
    }
  }
}

#map-chart {
  height: 93%;
}

::v-deep .vue-echarts-inner {
  height: 100%;
}

/* Mobile and tablet styles */
@media (max-width: 768px) {
  .graphs-info-container {
    grid-template-columns: 1fr;
    gap: 16px;

    &__item {
      min-height: 450px;

      &--fourth,
      &--fifth,
      &--sixth {
        grid-column: span 1;
      }

      &.long-map {
        grid-column: span 1;
      }
    }
  }

  .chart {
    height: 350px !important;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .graphs-info-container {
    grid-template-columns: repeat(2, 1fr);

    &__item {
      &--fourth {
        grid-column: span 2;
      }
      &--fifth,
      &--sixth {
        grid-column: span 1;
      }

      &.long-map {
        grid-column: span 2;
      }
    }
  }
}

@media (min-width: 1025px) and (max-width: 1234px) {
  .graphs-info-container {
    grid-template-columns: repeat(3, 1fr);

    &__item {
      &--fourth {
        grid-column: span 2;
      }
      &--fifth {
        grid-column: span 1;
      }
      &--sixth {
        grid-column: span 1;
      }

      &.long-map {
        grid-column: span 2;
      }
    }
  }
}

@media (min-width: 1235px) {
  .graphs-info-container {
    grid-template-columns: repeat(3, 1fr);
    &__item {
      &--first {
        grid-column: span 1;
      }
      &--second {
        grid-column: span 1;
      }
      &--third {
        grid-column: span 1;
      }
      &--fourth {
        grid-column: span 3;
      }
      &--fifth {
        grid-column: span 2;
      }
      &--sixth {
        grid-column: span 1;
      }
      &.long-map {
        grid-column: span 3;
      }
    }
  }
}

@media (min-width: 1635px) {
  .graphs-info-container {
    grid-template-columns: repeat(3, 1fr);
    &__item {
      &--first {
        grid-column: span 1;
      }
      &--second {
        grid-column: span 1;
      }
      &--third {
        grid-column: span 1;
      }
      &--fourth {
        grid-column: span 3;
      }
      &--fifth {
        grid-column: span 2;
      }
      &--sixth {
        grid-column: span 1;
      }
      &.long-map {
        grid-column: span 3;
      }
    }
  }
}
</style>
